import { ContractorActivityTypeEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { Col, Form, Input, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCmrInsuranceValues } from './CmrInsuranceContext'
import { formProps } from './utils'
import { ContractorTypeFields } from '../PersonsFields'

export const MainStep = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { isEditable } = useCmrInsuranceValues()

  const {
    contractorHeadProps,
    contractorContactRoleProps,
    contractorActivityTypeProps,
    contractorTransportLicense,
    modifyReasonProps
  } = formProps(t)

  const activityTypeOptions = Object.values(ContractorActivityTypeEnum).map(
    (value) => ({
      label: t(value),
      value
    })
  )

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <Form.Item {...contractorHeadProps} rules={[required]}>
            <Input placeholder={contractorHeadProps.label} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...contractorContactRoleProps} rules={[required]}>
            <Input placeholder={contractorContactRoleProps.label} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item {...contractorTransportLicense}>
            <Input placeholder={contractorTransportLicense.label} />
          </Form.Item>
        </Col>
      </Row>

      <ContractorTypeFields
        showBirthDate={false}
        showExperience={false}
        showSameContractorField={false}
        showResident={false}
        disableContractorType
      />

      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <Form.Item {...contractorActivityTypeProps} rules={[required]}>
            <Select
              placeholder={contractorActivityTypeProps.label as string}
              options={activityTypeOptions}
            />
          </Form.Item>
        </Col>
      </Row>

      {isEditable && (
        <Row gutter={[12, 12]}>
          <Col xs={24}>
            <Form.Item {...modifyReasonProps} rules={[required]}>
              <Input.TextArea placeholder={modifyReasonProps.label} rows={3} />
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  )
}
